<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Billing Promotion</span>
        </div>
    </div>
    <div class="card card_content">
        <div class="row d-flex justify-content-center align-items-center flex-wrap grid-margin">
     
            <div class="col-md-4">
                <div class="table_search">
                    <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                        style="margin-bottom: 1rem !important;">
                        <mat-label>Search</mat-label>
                        <div class="search-input-container">
                            <input placeholder="Enter Customer Number / Application / Name / Contact Number" id="search"
                                matInput (keyup)="applyFilter($event)" type="text" #searchInput>
                        </div>
                    </mat-form-field>
                </div>
            </div>
            <div class="col-md-2 mb-2">
                <!-- <button type="button" matRipple class="btn btn-secondary" (click)="searchreset()">
                    <i class="fa fa-refresh"></i> Refresh
                </button> -->
                <app-button (refreshClicked)="searchreset()"></app-button>

            </div>
          
        </div>

        <div class="table-responsive mt-2 mb-4">
            <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">

                <ng-container matColumnDef="providerName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="providerName">Provider Name</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <p class="text-truncate txtalign">
                            {{dataField.providerName}}</p>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="billingPromotionDays">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="billingPromotionDays">Days Of
                        Promotion</mat-header-cell>
                    <mat-cell *matCellDef="let dataField">
                        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'customsssss-mat-field'">
                            <input [ngModelOptions]="{standalone: true}" class="form-control customStyle" matInput
                                appAlphaNumeric maxlength="3" type="text" placeholder="Enter Promotion Days"
                                [(ngModel)]="dataField.billingPromotionDays" autocomplete="off" class="col-12">
                        </mat-form-field>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="transDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="transDate">Promotion Start
                        Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField; let i = index" class="date_picker">
                        <mat-form-field [ngClass]="'customsssss-mat-field'" class="custom-input" appearance="fill"
                            hideRequiredMarker>
                            <input [ngModelOptions]="{standalone: true}" [(ngModel)]="dataField.billingPromotionStartTs"
                                readonly matInput  [matDatepicker]="requestedcancellationTs"
                                id="requestedcancellationTs" autocomplete="off" placeholder="Promotion Start Date"
                                class="custom-input-border" specialIsAlphaNumeric
                                (click)="openRequestedCancellationTsDatePicker(i)"
                                [value]="dataField.billingPromotionStartTs"> <!-- Bind the value property -->
                            <mat-datepicker-toggle [id]="'PSclickId'+i" matSuffix [for]="requestedcancellationTs"
                                style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #requestedcancellationTs></mat-datepicker>
                        </mat-form-field>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="totalAmount">
                    <mat-header-cell *matHeaderCellDef mat-sort-header="totalAmount">Promotion End
                        Date</mat-header-cell>
                    <mat-cell *matCellDef="let dataField; let i = index" class="date_picker">
                        <mat-form-field [ngClass]="'customsssss-mat-field'" class="custom-input" appearance="fill"
                            hideRequiredMarker>
                            <input [ngModelOptions]="{standalone: true}" [(ngModel)]="dataField.billingPromotionEndTs"
                                readonly matInput  [matDatepicker]="returnDate" autocomplete="off"
                                placeholder="Promotion End Date" class="custom-input-border" specialIsAlphaNumeric
                                (click)="openReturnDatePicker(i)" [value]="dataField.billingPromotionEndTs">
                            <mat-datepicker-toggle [id]="'PEclickId'+i" matSuffix [for]="returnDate"
                                style="color:black;">
                                <button mat-icon-button>
                                    <mat-icon>event</mat-icon>
                                </button>
                            </mat-datepicker-toggle>
                            <mat-datepicker #returnDate></mat-datepicker>
                        </mat-form-field>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>

                <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                </mat-row>
            </mat-table>
        </div>
        <div class="row">
            <div class="col-12" style="text-align: end;">
                <button (click)="update()" class="btn btn-secondary button">Update</button>
            </div>
        </div>
    </div>
</div>